import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "item" };
const _hoisted_2 = { class: "item__image" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "item__main" };
const _hoisted_5 = { class: "item__title" };
const _hoisted_6 = { class: "item__info" };
const _hoisted_7 = { class: "item__sku" };
const _hoisted_8 = { class: "item__unit" };
const _hoisted_9 = { class: "item__quantity" };
const _hoisted_10 = {
    key: 0,
    class: "item__error"
};
import { ref } from 'vue';
import productUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import WatchlistUtils from "../services/WatchlistUtils";
import OrderUtils from "@astina/paloma-shop-common-ui/src/services/OrderUtils";
import NumberInput from "@astina/paloma-common-ui/src/components/NumberInput.vue";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistOrderItem',
    props: {
        item: {},
        watchlist: {}
    },
    emits: [
        'quantity-change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const unit = props.item.unitCode || props.item.variant && props.item.variant.baseOrderingUnit;
        const orderingUnit = props.item.variant && props.item.variant.orderingUnits
            .find(ou => ou.unitCode === unit)
            || WatchlistUtils.createOrderingUnitForWatchlistItem(props.item);
        const image = ref(null);
        const quantity = ref(0); // initialize with quantity 0 to prevent accidental orders
        const quantityPerPortion = ref(null);
        const quantityConfig = ref(WatchlistUtils.createQuantityConfig(props.item.quantity, orderingUnit, props.item.portions));
        const portioningMissing = ref(false);
        image.value = (props.item.image && productUtils.createImage(props.item.image, config.productImages.sizes.thumbnail)) || null;
        if (props.item.portions) {
            quantityPerPortion.value = OrderUtils.calculateQuantityPerPortion({ quantity: quantityConfig.value.initial, portions: props.item.portions }, quantityConfig.value);
        }
        // onQuantityChange(); // <-- did not work
        emit('quantity-change', props.item, quantity.value);
        function itemUnavailable() {
            if (props.item.variant && props.item.variant.availability && !props.item.variant.availability.available) {
                return true;
            }
            // Not available if portioning is required but no portioning is
            // configured on the watchlist item
            const portioning = quantityConfig.value.portioning;
            const portioningMissingLocal = !!(portioning && portioning === 'required' && !props.item.portionSize);
            portioningMissing.value = portioningMissingLocal;
            return portioningMissingLocal;
        }
        function onQuantityChange(quantityParam) {
            quantity.value = quantityParam;
            emit('quantity-change', props.item, quantity.value);
        }
        function decreaseQuantity() {
            if (itemUnavailable()) {
                return;
            }
            quantity.value = quantity.value - 1;
            if (quantityConfig.value.min != undefined && quantity.value < quantityConfig.value.min) {
                quantity.value = quantityConfig.value.min;
            }
            onQuantityChange(quantity.value);
        }
        function increaseQuantity() {
            if (itemUnavailable()) {
                return;
            }
            quantity.value = quantity.value + 1;
            if (quantityConfig.value.max !== undefined && quantity.value > quantityConfig.value.max) {
                quantity.value = quantityConfig.value.max;
            }
            onQuantityChange(quantity.value);
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (image.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: image.value.url,
                            alt: image.value.title
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.item.title), 1),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.item.sku), 1),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_8, [
                            (quantityConfig.value.portioningUnit)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('product.portions_of')) + " " + _toDisplayString(quantityPerPortion.value) + " " + _toDisplayString(_ctx.$t('unit.' + quantityConfig.value.portioningUnit)), 1)
                                ], 64))
                                : (quantityConfig.value.unit)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('unit.' + quantityConfig.value.unit)), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                        ])
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (decreaseQuantity()), ["prevent"])),
                            class: _normalizeClass(["button button--icon", { 'button--disabled': itemUnavailable() }]),
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "minus" })
                        ], 2),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createVNode(NumberInput, {
                            class: "item__input",
                            value: quantity.value,
                            min: quantityConfig.value.min,
                            max: quantityConfig.value.max,
                            decimals: quantityConfig.value.decimals,
                            "hide-controls": true,
                            "tab-index": 1,
                            disabled: itemUnavailable(),
                            onChange: onQuantityChange
                        }, null, 8, ["value", "min", "max", "decimals", "disabled"]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (increaseQuantity()), ["prevent"])),
                            class: _normalizeClass(["button button--icon", { 'button--disabled': itemUnavailable() }]),
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "plus" })
                        ], 2)
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (portioningMissing.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('watchlist_order.item_portioning_missing', { 'watchlist_name': __props.watchlist.name })), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
